import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import UserPortalNavBar from '../UserPortalNavBar'

class AccountSettingsNav extends Component {
  state = {
    tabs: [
      {
        title: 'Athlete Info',
        slug: 'athlete-info',
        path: '/settings/athlete-info'
      },
      {
        title: 'Account Info',
        slug: 'account-info',
        path: '/settings/account-info'
      },
      {
        title: 'Payment Info',
        slug: 'payment-info',
        path: ''
      },
      {
        title: 'Account Admins',
        slug: 'account-admins',
        path: '/settings/account-admins'
      },
      {
        title: 'Log Out',
        slug: 'log-out',
        path: '/log-out'
      },
    ],
  }

  componentDidMount() {
    this.handlePaymentInfoPath(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.handlePaymentInfoPath(nextProps)
  }

  handlePaymentInfoPath(props) {
    const { activeProfile } = props;

    let isSubscribed = activeProfile.subscribed ? activeProfile.subscribed : false

    let initialTabs = [...this.state.tabs];

    let paymentInfoTab = isSubscribed
    ? {
        title: 'Payment Info',
        slug: 'payment-info',
        path: '/settings/payment-info'
      }
    : {
      title: 'Payment Info',
      slug: 'payment-info',
      path: '/settings/payment-info/subscribe'
    }

    let updatedTabs = [
      ...initialTabs.slice( 0, 2 ),
      paymentInfoTab,
      ...initialTabs.slice( 3, 5)
    ]

    this.setState(state => ({
      ...state,
      tabs: updatedTabs
    }));
  }

  render() {
    const { currentTab } = this.props;
    const { tabs } = this.state;

    return (
      <nav className="account-settings-nav">
        <UserPortalNavBar currentTab={currentTab} tabs={tabs} />
      </nav>
    );
  }
}

const mapStateToProps = state => {
  return {
    activeProfile: state.activeProfile,
  }
}

export default connect(
  mapStateToProps,
  null
)(AccountSettingsNav)



// WEBPACK FOOTER //
// ./src/components/UserPortal/AccountSettings/AccountSettingsNav.js